import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as $ from 'jquery';
window['$'] = $;
window['jQuery'] = $;
if (environment.production) {
    enableProdMode();
    // if (window) {
    //   window.console.log = function () {
    //   };
    // }
}
platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(function (err) { return console.log(err); });



//////////////////
// WEBPACK FOOTER
// ./src/main.ts
// module id = ./src/main.ts
// module chunks = main